// src/components/states/bayern.js
export const bayern = {
  slug: "bayern",
  name: "Bayern",
  hero: {
    eyebrow: "Bundesland-Übersicht",
    title: "Erdwärme in Bayern",
    subtitle:
      "Übersicht zu Förderung, Genehmigungen, Datengrundlage (UmweltAtlas/Energie-Atlas) und typischen Standortfaktoren in Bayern – kompakt und praxisnah.",
    infoBox:
      "Bayern hat sehr klare Prozessbeschreibungen: Bohranzeige über Kreisverwaltungsbehörde + GeolDG-Anzeige an das LfU; ab 100 m und/oder >0,2 MW kommen bergrechtliche Anforderungen dazu.",
  },
  seo: {
    title:
      "Erdwärme in Bayern – Förderung, Genehmigung & Daten (UmweltAtlas) | Erdwärme-Experten",
    description:
      "Kurzübersicht Erdwärme Bayern: Förderung (KfW), Genehmigungen/Bohranzeige (KVB, wasserrechtliche Erlaubnis), GeolDG-Anzeige (LfU), Datenlage (UmweltAtlas/Standortauskunft) und Untergrund/Grundwasser.",
    canonical: "https://www.erdwaerme-experten.de/bundeslaender/bayern",
  },

  facts: [
    {
      title: "Förderung (Bund)",
      icon: "BadgeCheck",
      color: "from-rose-600 to-rose-500",
      bullets: [
        "Heizungstausch-Zuschuss über KfW Programm 458 für Bestandsgebäude",
        "30 % Grundförderung; persönliche Boni können die Quote erhöhen",
        "Maximal 80 %; kein separater Effizienzbonus für Erdwärme",
      ],
      note:
        "Förderstand 21.07.2026. Die tatsächliche Förderfähigkeit hängt von Gebäude, Eigentum, Einkommen und weiteren Voraussetzungen ab.",
      link: {
        label: "KfW 458 (offiziell)",
        href: "https://www.kfw.de/inlandsfoerderung/Privatpersonen/Bestehende-Immobilie/F%C3%B6rderprodukte/Heizungsf%C3%B6rderung-f%C3%BCr-Privatpersonen-Wohngeb%C3%A4ude-%28458%29/",
      },
    },
    {
      title: "Genehmigung & Vorgehen",
      icon: "ShieldCheck",
      color: "from-slate-700 to-slate-600",
      bullets: [
        "Wenn ein Eingriff in das Grundwasser möglich ist: wasserrechtliche Erlaubnis erforderlich (Antrag bei Kreisverwaltungsbehörde; fachlich begleitet durch Wasserwirtschaftsamt).",
        "Bis 100 m: Bohranzeige bei Kreisverwaltungsbehörde + GeolDG-Anzeige beim LfU.",
        "Ab >100 m und/oder bei thermischer Leistung >0,2 MW: zusätzlich Genehmigung/Anforderungen der Bergbehörde.",
        "Bei 100–400 m: Anzeigepflicht gegenüber Bergbehörde; bergrechtliche Bewilligung erst >400 m (laut Energie-Atlas Bayern).",
      ],
      note:
        "Praxis-Tipp: Früh klären, ob ein wasserrechtliches Verfahren nötig ist (Standort/Grundwasser/Schutzgebiete).",
      link: {
        label: "Energie-Atlas Bayern: Planung & Genehmigung",
        href: "https://www.energieatlas.bayern.de/erneuerbare-energien/oberflaechennahe-geothermie/planung-genehmigung",
      },
    },
    {
      title: "Datengrundlage (UmweltAtlas & Standortauskunft)",
      icon: "Layers",
      color: "from-indigo-700 to-indigo-600",
      bullets: [
        "UmweltAtlas Bayern: standortbezogene Erstauskunft zur Eignung (Sonde/Kollektor/Grundwasser-WP).",
        "PDF-Standortauskunft mit geologischen und (unverbindlichen) wasser-/hydrogeologischen Informationen.",
        "Energie-Atlas Bayern als zentrale Einstiegsseite zur oberflächennahen Geothermie.",
      ],
      note:
        "Für Bayern kannst du sehr gut ‚Datenlage‘ auf der Seite zeigen, weil es klare Portale + Standort-PDFs gibt.",
      link: {
        label: "LfU: Oberflächennahe Geothermie (UmweltAtlas/Standortauskunft)",
        href: "https://www.lfu.bayern.de/geologie/oberflaechennahe_geothermie/index.htm",
      },
    },
    {
      title: "Bohranzeige – konkret",
      icon: "Drill",
      color: "from-emerald-700 to-emerald-600",
      bullets: [
        "Bohrungen zur Errichtung von Erdwärmesondenanlagen sind bei der zuständigen Kreisverwaltungsbehörde anzuzeigen.",
        "Wenn Bohrungen bis ins Grundwasser reichen: i. d. R. wasserrechtliche Erlaubnis erforderlich.",
        "Geologische Untersuchungen (inkl. Bohrungen) sind dem LfU zwei Wochen vor Beginn anzuzeigen.",
      ],
      note:
        "Die Fristen/Details können je nach Fall variieren – im Zweifel die zuständige Behörde bzw. die Energie-Atlas/LfU Hinweise nutzen.",
      link: {
        label: "BayernPortal: Bohranzeige Erdwärmesonden",
        href: "https://www.bayernportal.de/dokumente/leistung/69886183583",
      },
    },
  ],

  dataCards: [
    {
      title: "Welche Daten sind verfügbar?",
      icon: "Layers",
      desc:
        "Sehr starke Portale: UmweltAtlas Bayern (Standortauskunft + PDF) und Energie-Atlas Bayern. Ideal für eine schnelle, standortbezogene Vorprüfung.",
    },
    {
      title: "Was ist häufig der Engpass?",
      icon: "ThermometerSun",
      desc:
        "Wasserrecht (Grundwasser/Schutzgebiete), die lokale Bohrlogistik und ab >100 m bzw. >0,2 MW zusätzliche bergrechtliche Anforderungen.",
    },
    {
      title: "Was macht euer GeoReport daraus?",
      icon: "FileText",
      desc:
        "Zusammenführung von Standortdaten + erste Dimensionierung (Sonden/Kollektor) und Kosten-/Förderlogik, um Angebote besser einordnen zu können.",
    },
  ],

  faq: [
    {
      q: "Wie läuft die Antragstellung in Bayern grob ab (bis 100 m)?",
      a: "Laut Energie-Atlas Bayern: Bohranzeige bei der Kreisverwaltungsbehörde (KVB) und zusätzlich GeolDG-Anzeige beim LfU. Die KVB prüft, ob ein Antrag auf wasserrechtliche Erlaubnis notwendig ist; begonnen werden darf erst nach Erlaubnis bzw. unter den dort beschriebenen Bedingungen.",
      links: [
        {
          label: "Energie-Atlas Bayern: Planung & Genehmigung",
          href: "https://www.energieatlas.bayern.de/erneuerbare-energien/oberflaechennahe-geothermie/planung-genehmigung",
        },
      ],
    },
    {
      q: "Was gilt bei Anlagen tiefer als 100 m oder größerer Leistung?",
      a: "Laut Energie-Atlas Bayern: Wenn die Bohrung tiefer als 100 m ist und/oder die thermische Leistung >0,2 MW liegt, muss eine Genehmigung bei der zuständigen Bergbehörde beantragt werden. Für 100–400 m gilt außerdem eine Anzeigepflicht gegenüber der Bergbehörde.",
      links: [
        {
          label: "Energie-Atlas Bayern: Planung & Genehmigung",
          href: "https://www.energieatlas.bayern.de/erneuerbare-energien/oberflaechennahe-geothermie/planung-genehmigung",
        },
      ],
    },
    {
      q: "Gibt es eine zentrale Standortauskunft für Bayern?",
      a: "Ja. Das LfU beschreibt, dass seit 2017 die Fachthemen im UmweltAtlas Bayern liegen und dort eine standortbezogene Erstauskunft (inkl. PDF) zur Eignung für Sonde/Kollektor/Grundwasserwärmepumpe verfügbar ist.",
      links: [
        {
          label: "LfU: UmweltAtlas / Standortauskunft",
          href: "https://www.lfu.bayern.de/geologie/oberflaechennahe_geothermie/index.htm",
        },
      ],
    },
  ],

  cta: {
    title: "Bayern-Standort prüfen (datenbasiert)",
    text:
      "Du bekommst eine standortbezogene Vorabschätzung: Untergrundparameter (soweit verfügbar), erste Dimensionierung, Kosten-/Förderlogik und typische Genehmigungshinweise.",
    primary: {
      label: "Jetzt Standort-Report erstellen",
      href: "/report",
      title: "Erdwärme Standort-Report für Bayern erstellen",
    },
    secondary: { label: "Erst Grundlagen ansehen", href: "/flache-geothermie" },
    footnote:
      "Tipp: In Bayern lohnt ein Blick in die UmweltAtlas-Standortauskunft – sie ist oft ein schneller Startpunkt für die Vorprüfung.",
  },
};
